import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DocumentVaultMasterModule } from './main/document-vault-master/document-vault-master.module';
import { Menus } from './shared/constants/menu.constant';
import { Roles } from './shared/constants/roles.constant';
import { AuthGuardService as AuthGuard } from './shared/guard/authorization-guard.service';
import { AttendanceModule } from 'app/main/attendance/attendance.module';
// import { QrAttendanceComponent } from './main/qr-attendance/qr-attendance.component';


const routes: Routes = [
    {
        path: 'dashboard',
        loadChildren: () => import('app/main/dashboard/dashboard.module').then(m => m.DashboardModule),
    },
    {
        path: 'documentVault',
        loadChildren: () => import('app/main/document-vault-master/document-vault-master.module').then(m => DocumentVaultMasterModule),
    },
    {
        path: 'attendance',
        loadChildren: () => import('app/main/attendance/attendance.module').then(m => AttendanceModule),
    },
    // {
    //     path: 'qr-attendance',
    //     component: QrAttendanceComponent,
    // },
    {
        path: 'authorization',
        loadChildren: () => import('app/authentication/authentication.module').then(m => m.AuthenticationModule),
    },
    {
        path: 'sample',
        loadChildren: () => import('app/main/sample/sample.module').then(m => m.SampleModule),
        //canActivate: [AuthGuard], data: { roles: [Roles.ADMINISTRATOR] }
    },
    {

        path: 'master',
        loadChildren: () => import('app/main/master/master.module').then(m => m.MasterModule),
        
        //canActivate: [AuthGuard], data: { roles: [Roles.ADMINISTRATOR] }

    },
    {

        path: 'utility',
        loadChildren: () => import('app/main/utility/utility.module').then(m => m.UtilityModule),
        // canActivate: [AuthGuard], data: { roles: [Roles.ADMINISTRATOR] }

    },
    {
        path: 'transaction',
        loadChildren: () => import('app/main/transaction/transaction.module').then(m => m.TransactionModule),
        // canActivate: [AuthGuard], data: { roles: [Roles.ADMINISTRATOR] }

    },
    {

        path: 'report',
        loadChildren: () => import('app/main/report/report.module').then(m => m.ReportModule),
        // canActivate: [AuthGuard], data: { roles: [Roles.ADMINISTRATOR] }

    },
    {

        path: 'my-profile',
        loadChildren: () => import('app/main/my-profile/my-profile.module').then(m => m.MyProfileModule),
        // canActivate: [AuthGuard], data: { roles: [Roles.ADMINISTRATOR] }

    },
    {

        path: 'payroll-master',
        loadChildren: () => import('app/main/payroll-master/payroll-master.module').then(m => m.PayrollMasterModule),
        // canActivate: [AuthGuard], data: { roles: [Roles.ADMINISTRATOR] }

    },
    {
        path: '**',
        redirectTo: 'authorization',
        pathMatch: 'full'
    },

];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
